<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!-- <b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row> -->
		 
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Product Requests</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid class="mt-3 mb-2">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
					
					
					<!--<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								 <b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button> <b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							</b-col>
							
							  
							<b-col lg="6"  class="text-right">
								 <b-button size="sm mr-2" @click="settoActiveproduct">Active Product</b-button>
							</b-col>
						</b-row>-->
					
						<b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-100">
								</b-form-select>
								
							</b-col>
							<!-- <b-col lg="2" class="text-left">
								<span class="mr-2">Brand</span>
								<b-form-select v-model="reg_brand" required size="sm">
									<b-form-select-option value="null">All Brand</b-form-select-option>
									<b-form-select-option v-for="sellerRor in sellerList" :value="sellerRor.brand_name"  :key="sellerRor.user_id" >{{sellerRor.brand_name+' ('+sellerRor.productCount+')'}}</b-form-select-option>
									
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col> -->
							
							<b-col lg="6"  >
								&nbsp;
							</b-col>
							
							<b-col lg="4"  >
								<b-form-group label="Filter" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm" class="m-0">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" 
								>  <!-- :select-mode="selectMode"
								ref="selectableTable"
								selectable @row-selected="onRowSelected" -->
								
									
								  
								 <!--  <template v-slot:cell(selected)="{ rowSelected }">
										<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								</template> -->
								 <template v-slot:cell(brand_name)="row">
									
                                       <b-link :href="'/brand/'+row.value" target="_blank "> {{row.value}} </b-link>
                                    </template>
								
								 <template v-slot:cell(brand_logo)="row">
									
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../../assets/icons/blank.svg">{{row}}</b-img>
                                       <!-- <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'products/'+(row.value).replace('_rg','_th')">{{row}}</b-img> -->
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'brands/'+row.value.replace('_rg','_th')">{{row}}</b-img>
                                    </template>
									
									<template v-slot:cell(seller)="row">
										<ul class="p-0">
											<li>Name: {{row.value || '---'}}</li> 
											<li>Business : {{row.item.business_name || '---' }}</li> 
											<li>Email : {{row.item.email || '----'}}</li> 
										</ul>
                                        
                                    </template>
								
									<template v-slot:cell(inmenu)="row">
										<!--<b-badge pill variant="warning" >WAITING</b-badge>-->
										<b-link v-if="row.value == 1" @click="updateinmenuStatus(row.item, 0)">
										<b-badge pill variant="success" >ACTIVE</b-badge>
										</b-link>
										<b-link @click="updateinmenuStatus(row.item,1)" v-else>
										<b-badge pill variant="danger" >INACTIVE</b-badge></b-link>
									</template>
								
									<template v-slot:cell(status)="row">
										
										<b-link @click="updateStatus(row.item, 0)" v-if="row.value == 1"> <b-badge pill variant="success"   >ACTIVE</b-badge></b-link >
										<b-link @click="updateStatus(row.item, 1)" v-else>
										<b-badge pill variant="danger"  >INACTIVE</b-badge></b-link >
									</template>
                                    <template v-slot:cell(totalBanner)="rowB">
										<b-link @click="showBrandBanner(rowB.item.id,rowB.value),activeBrandName=rowB.item.brand_name"><b-badge pill variant="warning"  >{{rowB.value || 0 }}</b-badge></b-link>
										
									</template>
                                    
                                    
                                   
									<template v-slot:cell(actions)="row">
										<!--<b-button pill variant="primary" class="mr-1 icon-btn" @click="updateStatus(row.item, 1)"><b-icon icon="check2" font-scale="1.8" ></b-icon></b-button> -->
										<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="updatebrandDelete(row.item, 1)"><b-icon icon="x" font-scale="1.8" ></b-icon></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	
	
					<b-modal id="bannerBrand" :title="activeBrandName" size="sm" class="bannerbrandmodel" hide-footer="true">
							
								<b-container fluid>
								
								<b-table-simple  small caption-top responsive>
															
									<b-thead head-variant="light">
										<b-tr>
											<b-th >Banner</b-th>
											<b-th >Action</b-th>
										</b-tr>
									</b-thead>
									<b-tbody>
										<b-tr v-for="bannerRow in bannerList" :key="bannerRow.id">
											<b-th> 
											
											  <b-img v-bind="thumbnailBanner" rounded alt="" :src="$root.MEDIAPATH+'brands/banner/'+bannerRow.image"></b-img>
											</b-th>
											<b-th >
												<b-link @click="updateBannerStatus(bannerRow.id, 0,bannerRow.brand_id)" v-if="bannerRow.status == 1"> <b-badge pill variant="success" >ACTIVE</b-badge></b-link >
												<b-link @click="updateBannerStatus(bannerRow.id, 1,bannerRow.brand_id)" v-else>
												<b-badge pill variant="danger"  >INACTIVE</b-badge></b-link >
											
											</b-th>
										</b-tr>
										
										
								   </b-tbody>

								</b-table-simple>
								
										
									
								</b-container>
							
							<!--<template v-slot:modal-footer="{ ok, close }">
								<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
								
							</template> -->
						</b-modal>			

	
	
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            thumbnailBanner: { blank: false, width: 120, height: 60, class: 'm1' },
            product_inf: {},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/product-brand',
			updateStatusUrl: this.$root.WEBAPI+'secureapi/brand-status-update',
			updateinmenuUrl: this.$root.WEBAPI+'secureapi/brand-inmenu-update',
			updateDeleteUrl: this.$root.WEBAPI+'secureapi/brand-delete-update',
			getbrandbannerUrl: this.$root.WEBAPI+'secureapi/getbrand-banner',			
			updateBannerStatusUrl: this.$root.WEBAPI+'secureapi/banner-status-update',			
			updateUrl: this.$root.WEBAPI+'secureapi/productstatus-update',
			updateBulkUrl: this.$root.WEBAPI+'secureapi/productstatus-updatebulk',
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
               /* { key: 'Selected',label: 'Selected'}, 
                { key: 'id', label: 'ID'},*/
               
                { key: 'brand_name', label: 'Brand Name'},
				{ key: 'brand_logo', label: 'Brand Logo'},
				{ key: 'seller', label: 'Seller'},
				{ key: 'inmenu', label: 'Logo In Menu' },
				{ key: 'status', label: 'Status' },
				{ key: 'totalBanner', label: 'Brand Banner' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1,
			 selectMode: 'multi',
			 selected: [],
			 sellerList: [],
			 reg_brand:null,
			 activeBrandName:'',
			 bannerList:[],
		};
	},
	methods: {
		onRowSelected(items) {
			this.selected = items
		  },
		  selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected()
		  },
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		
		updatebrandDelete(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to Delete Brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateDeleteUrl, {
						accesskey: self.$session.get('access_key'),
                        bannerId: item.id,
                        status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		updateStatus(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){ 
					self.axios.post(self.updateStatusUrl, {
						accesskey: self.$session.get('access_key'),
						bannerId: item.id,
						status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		updateinmenuStatus(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateinmenuUrl, {
						accesskey: self.$session.get('access_key'),
						bannerId: item.id,
						status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		settoActiveproduct(){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to approve all product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateBulkUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: self.selected,
                        status: 1
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}else{
							self.$bvToast.toast(response.data.message, {
									title: 'Update Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
						
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.brandList;
					self.sellerList = response.data.result.sellerList;
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				brandName: self.reg_brand
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.brandList;
					self.sellerList = response.data.result.sellerList;
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		showBrandBanner(itemId,totoalBanner){
			var self = this;
			if(totoalBanner>0){
			self.axios.post(self.getbrandbannerUrl, {
					accesskey: self.$session.get('access_key'),
					bannerId: itemId,
					
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.bannerList = response.data.result.bannerList;
						if(totoalBanner<50){
							self.$root.$emit('bv::show::modal', 'bannerBrand');
						}
						//self.initload();
					}else{
						self.$bvToast.toast(response.data.message, {
							title: 'Banner Info',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
					
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}else{
			self.$bvToast.toast('No Banner on this Brand! ', {
							title: 'Update Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
			}
			
		},
		updateBannerStatus(rowId, status,bannerRowId){
			
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update Banner Satatus!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){ 
					self.axios.post(self.updateBannerStatusUrl, {
						accesskey: self.$session.get('access_key'),
						bannerId: rowId,
						status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							self.showBrandBanner(bannerRowId,50);
							
							
							//self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},

		
	}
}
</script>
<style lang="scss">

	.modal-title{
		text-transform: capitalize;
	}


</style>